import { useCallback } from 'react'
import { INTEGRATION_EXEMPT_ACCOUNT_IDS } from './integrationRequirement'
import { IntegrationServiceId } from './integrations'
import { useAccount } from './useAccount'

/** Returns a checker that determines if the current account is exempt from the Zoom integration requirement. */
export const useIsZoomExempt = () => {
  const { accountId, account } = useAccount()
  const parentId = account?.parentId
  const zoomAnonymousJoinException = account?.effectiveConfig.zoomAnonymousJoinException

  return useCallback((): boolean => {
    // Hardcoded safety net
    const exemptIds = INTEGRATION_EXEMPT_ACCOUNT_IDS[IntegrationServiceId.ZOOM]
    const hardcodedExempt = exemptIds ? exemptIds.has(accountId) || (parentId ? exemptIds.has(parentId) : false) : false

    if (hardcodedExempt) {
      return true
    }

    // Config-driven exemption
    return zoomAnonymousJoinException ?? false
  }, [accountId, parentId, zoomAnonymousJoinException])
}
